// 设置路由
import Layout from '@/view/layout' // 主框架

export default {
  path: '/test',
  component: Layout,
  children: [
    {
      path: 'test',
      component: () => import('@/view/staffManagement/SalesmanFinder'),
      name: 'test'
    }
  ]
}
